import { PATHNAMES } from "src/constants/routes";
import { menuTrns } from "./trns";

export const IS_ACTIVE_UPDATE_PASSWORD_KEY = "isActiveUpdPass";
export const IS_EMAIL_CONFIRM_KEY = "isEmailConfirm";
export const TRUE = "true";
export const FALSE = "false";

export const MENU_ITEMS = [
  {
    id: 1,
    title: {
      i18nKey: menuTrns.clones,
    },
    path: PATHNAMES.CLONES,
  },
  {
    id: 2,
    title: {
      i18nKey: menuTrns.inquiries,
    },
    path: PATHNAMES.INQUIRIES,
  },
  {
    id: 3,
    title: {
      i18nKey: menuTrns.opportunities,
    },
    path: PATHNAMES.OPPORTUNITIES,
  },
  {
    id: 4,
    title: {
      i18nKey: menuTrns.aboutUs,
    },
    path: PATHNAMES.ABOUT_US,
  },
  {
    id: 5,
    title: {
      i18nKey: menuTrns.contactUs,
    },
    path: PATHNAMES.CONTACT_US,
  },
  {
    id: 6,
    title: {
      i18nKey: menuTrns.blog,
    },
    path: PATHNAMES.BLOG,
  },
];
